import React from "react";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";

const Breadcrumb = ({title}) => {
  return (
    <div className='d-flex flex-wrap align-items-center justify-content-between gap-3 mb-16'>
      <h6 className='text-md fw-bold mb-0' style={{color:"#10477fe3"}}>{title || "Dashboard"}</h6>
      <ul className='d-flex align-items-center gap-2'>
        <li className='fw-medium'>
          <Link to='/' className='d-flex align-items-center gap-1 hover-text-primary' style={{color:"#10477fe3"}}>
            <Icon icon='mdi:view-dashboard' className='icon text-sm'/> Dashboard 
          </Link>
        </li>
        <li className='d-flex'><Icon icon="mdi:chevron-right" className="icon text-lg" style={{color:"#10477fe3"}} /> </li>
        <li className='fw-medium text-sm' style={{color:"#10477fe3"}}>{title}</li>
      </ul>
    </div>
  );
};
export default Breadcrumb;
